/**
 * Asynchronously loads the component for ProfileSettingPage
 */

import { lazyLoad } from "@utils/loadable";

export const ProfileSettingPage = lazyLoad(
  () => import("./index"),
  (module) => module.default
);
